import React from 'react';

import { Company, CompanyEmployee, MarketCode, RoleEmployee } from '@homesusa/core';

export const AuthCompanyContext = React.createContext<{
  currentEmployee?: CompanyEmployee;
  currentMarket: MarketCode;
  currentCompany?: Company;
  userCompanies?: Company[];
  setCurrentCompany: (newCompany: Company | null, marketCode?: MarketCode) => Promise<void>;
  setEmployeeRole: (role?: RoleEmployee) => Promise<void>;
  refreshing: boolean;
  disabled: boolean;
}>(Object.assign({ disabled: true, currentMarket: MarketCode.Sabor }));
